module.exports = __webpack_public_path__ + "static/media/card-img.8da7bd6b.png";